"use client";

import React from "react";

type T_ChatRenderContextValue = {
  isStreaming: boolean;
};

const CHAT_RENDER_CONTEXT_DEFAULT: T_ChatRenderContextValue = {
  isStreaming: false,
};

const ChatRenderContext = React.createContext<T_ChatRenderContextValue>(
  CHAT_RENDER_CONTEXT_DEFAULT,
);

export function ChatRenderProvider({
  children,
  isStreaming,
}: React.PropsWithChildren<{ isStreaming?: boolean }>) {
  const value = React.useMemo(
    () => ({
      isStreaming: isStreaming ?? false,
    }),
    [isStreaming],
  );

  return (
    <ChatRenderContext.Provider value={value}>
      {children}
    </ChatRenderContext.Provider>
  );
}

export function useChatRenderContext(): T_ChatRenderContextValue {
  return React.useContext(ChatRenderContext);
}
